<div class="unsave-changes-warning" role="dialog">
  <gstar-header-modal [id]="modalId" [hasCloseButton]="true">
    <h4 class="fs-4">
      {{ 'countryInformation.unsaveChangesWarningTitle' | translate }}
    </h4>
  </gstar-header-modal>
  <gstar-body-modal>
    <p>{{ 'countryInformation.unsaveChangesWarningMessage' | translate }}</p>
  </gstar-body-modal>
  <gstar-footer-modal
    [id]="modalId"
    [isEnabled]="!disabledSaveButton"
    [primaryButtonLabel]="'shared.save' | translate | uppercase"
    [secondaryButtonLabel]="'shared.discard' | translate | uppercase" />
</div>
